var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "globalG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 2,
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5391,
    y: 7.36401,
    width: 4.09091,
    height: 20.4545,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.35938,
    y: 19.6367,
    width: 4.09091,
    height: 20.4545,
    transform: "rotate(-90 7.35938 19.6367)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.36b0eaf2d5e861214f17daf34bbda61b.svg";
export { ForwardRef as ReactComponent };